import Vue from 'vue'
import Vuex from 'vuex'
import Usuario from "./usuario";
import Establecimientos from "./establecimientos";
import Series from "./series";
import Ventas from "./ventas";
import Compras from "./compras";
import Personas from "./personas";
import Transaccion from "./transaccion";
import Facturas from "./facturasfel";
import TransaccionDetalles from './transacciondetalle'
import TransaccionMedioPago from './transaccionmediopago'
import Contacto from "@/components/contribuyentes/contacto/contacto.vuex";
import Claves from "@/components/contribuyentes/claves/claves.vuex";
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    IdContribuyente:0,
    //urlapi:'https://hermanosyasociados.microsystems.com.gt/api/v1', //Prod
    //urlapi:'https://asecontables.microsystems.com.gt/api/v1',
    //urlapi:'https://contasolis.microsystems.com.gt/api/v1',
    //urlapi:'https://contamillennium.up.railway.app/api/v1',
    urlapi:'https://democontaapi.up.railway.app/api/v1', //Dev
    
    //urlapi:'http://[::1]:3000/api/v1', //Dev
  },
  mutations: {},
  actions:{},
  getters:{
    getUrlApi(state){
      return state.urlapi
    }
  },
  modules:{
    Usuario,Establecimientos,Series,Ventas,Compras,Personas,Facturas,Transaccion,
    TransaccionDetalles,TransaccionMedioPago,Contacto,Claves
  }
})

export default store 